import { POLL_TIMEOUT } from '../config';

const poll = (
  fn,
  condition = f => f,
  successCallback = f => f,
  errorCallback = f => f,
  completionCallback = f => f,
  timeout = POLL_TIMEOUT,
) => {
  if (!process.env.BROWSER) {
    return f => f;
  }

  if (typeof fn !== 'function') {
    throw new Error(`POLLING: argument fn: ${fn} is not a function`);
  }

  if (typeof condition !== 'function') {
    throw new Error(
      `POLLING: argument condition: ${condition} is not a function`,
    );
  }

  if (typeof successCallback !== 'function') {
    throw new Error(
      `POLLING: argument  successCallback: ${successCallback} is not a function`,
    );
  }

  if (typeof errorCallback !== 'function') {
    throw new Error(
      `POLLING: argument  errorCallback: ${errorCallback} is not a function`,
    );
  }

  if (typeof completionCallback !== 'function') {
    throw new Error(
      `POLLING: argument  completionCallback: ${completionCallback} is not a function`,
    );
  }

  let timeoutId;

  const pollOnce = () => {
    timeoutId = setTimeout(
      () =>
        fn().then(
          result => {
            clearTimeout(timeoutId);
            if (condition()) {
              pollOnce();
              successCallback(result, timeoutId);
            } else {
              completionCallback(result, timeoutId);
            }
          },
          error => {
            clearTimeout(timeoutId);
            errorCallback(error);
          },
        ),
      timeout,
    );
  };

  pollOnce();
  return timeoutId;
};

export default poll;



// WEBPACK FOOTER //
// ./src/utils/polling.js